<!--图文：上下结构 标题+描述+图片+顺序-->
<template>
  <div class="v-imgtext">
    <!-- 图片+顺序 -->
    <div>
      <el-row  :gutter="10">
        <el-col  :xs="getGrid(type,position,imgtextVal.card.carditem.length,0)" 
                 :sm="getGrid(type,position,imgtextVal.card.carditem.length,1)" 
                 :md="getGrid(type,position,imgtextVal.card.carditem.length,2)" 
                 :lg="getGrid(type,position,imgtextVal.card.carditem.length,3)" 
                 :xl="getGrid(type,position,imgtextVal.card.carditem.length,4)"
                v-for="(item,index) in imgtextVal.card.carditem" 
                :key="index" 
                :class="imgStyle+' '+imgTextClass+' '+type+'ImgText imgOne'"
                @click.native="linkUrl(item.url)">
          <!-- 1上下 -->
          <div :class="item.url?' click imgtextTB ' + duty :'imgtextTB ' + duty" 
               v-if="position=='top-bottom'">
            <img :src="address+item.img"   
                 :onerror="deaImg"
                 :class="item.img!==''&&item.txt!==''?'my' + imgStyle:'imgA'"
                 v-if="item.img" />
            <div :class="item.img!==''&&item.txt!==''?'content':'contentA'" v-if="item.txt" v-html="mark(item.txt)"></div>
          </div>
          <!-- 2下上 -->
          <div :class="item.url?' click imgtextBT ' + duty :'imgtextTB ' + duty" 
              v-else-if="position=='bottom-top'">
              <div class="content" v-if="item.txt" v-html="mark(item.txt)"></div>
              <img :src="address+item.img" :onerror="deaImg"  v-if="item.img"/>
          </div>
          <!-- 3左右 -->
          <el-row :class="item.url?' click ' + duty+'A' : duty+'A'" 
                        v-else-if="position=='left-right'">
            <el-col :span="getGridOne(item.txt,item.img,duty,0)"><img  :src="address+item.img" 
                  :class="'my' + imgStyle"
                  :onerror="deaImg"/></el-col>
            <el-col :span="getGridOne(item.txt,item.img,duty,1)"><div class="content" 
                  v-if="item.txt!==''"
                  v-html="mark(item.txt)"></div></el-col>
          </el-row>
          <!-- 4右左 -->
          <el-row :class="item.url?' click ' + duty+'B' :duty+'B' "  v-else>
            <el-col :span="getGridOne(item.txt,item.img,duty,1)"><div class="content" 
                  v-if="item.txt" v-html="mark(item.txt)"></div></el-col>
            <el-col :span="getGridOne(item.txt,item.img,duty,0)"><img  :src="address+item.img" 
                  :class="'my' + imgStyle"
                  :onerror="deaImg"/></el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import marked from 'marked'
export default {
  name: 'v-imgtext',
  props: {
      imgtextVal: null //这样可以指定传入的类型，如果类型不对，会警告
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      imgStyle:"rect",//图片样式
      imgTextClass:"",//单个图文样式
      type:"x_middle",//类型
      // deaImg:require('../assets/images/dea.jpg'),
      // address:"http://10.16.54.158:9018",
      address:"",
      deaImg:"",
      // deaImg: 'this.src="' + require('@/assets/images/jiantou.png') + '"',
      defaultOpen:"preview",
      position:"left-right",//top-bottom bottom-top left-right right-left
      duty:"dutyOne",//比列图:内容 dutyOne 3:1 、dutyTwo 2:2 、dutyThree 1:3 左右跟比例有关系，上下跟高度有关系
    }
  },
  created(){
    var that = this;
    // console.log("position:::",that.imgtextVal);
    that.position = that.getAttr(that.imgtextVal.card.attr,"position");
    that.imgStyle = that.getAttr(that.imgtextVal.card.attr,"imgStyle")?that.getAttr(that.imgtextVal.card.attr,"imgStyle"):"";
    that.imgTextClass = that.getAttr(that.imgtextVal.card.attr,"imgTextClass")?that.getAttr(that.imgtextVal.card.attr,"imgTextClass"):"";
    // console.log("that.imgtextVal.card.attr::",that.imgTextStyle);
    that.type = that.getAttr(that.imgtextVal.card.attr,"size")?that.getAttr(that.imgtextVal.card.attr,"size"):"x_small";
    that.duty = that.getAttr(that.imgtextVal.card.attr,"duty")?that.getAttr(that.imgtextVal.card.attr,"duty"):"dutyOne";
  },
  methods:{
    linkUrl(_url){
      var that = this;
      if(_url!==""&&_url!==null){
        if(_url.indexOf("http")>=0||_url.indexOf("https")>=0){
          window.open(_url);
        }else{
          that.$router.push({'name':'build',query:{"id":_url}});
        }
      }
      return;
    },
    //转换md格式
    mark(_value){
      return marked(_value);
    },
    //转换样式
    getAttr(_attr,_type){
      var data={};
      if(_attr!==''){
        data=JSON.parse(_attr);
        return data.[_type];
      }
    },
    //图文排列栅格
    getGrid(_size,_position,_length,_screen){
        //_size "x_small"、"x_middle"、"x_large"、"x_largel"
        //_position "top-bottom"、"bottom-top"、"left-right"、"right-left" 目前没用，缺少一个比例参数
        //_length 个数
        //_screen 0:xs、1:ml、2:md、3:lg、4:xl
        var position = (_position=="left-right"||_position=="right-left")?0:1;
        var grid = 24;
        if(_size=="x_middle"){
          switch (_screen) {
            case 0:
              grid =  _length>1 && position?12:24;
              break;
            case 1:
              grid =  _length>1?12:24;
              break;
            case 2:
              grid = _length>1?12:24;
              break;
            case 3:
              grid = _length>2?8:_length>1?12:24;
              break;
            case 4:
              grid = _length>2?8:_length>1?12:24;
              break;
            default:
              grid = 24;
          }
            // grid = _length>3?6:_length>2?8:_length>1?12:24;
        }else if(_size=="x_large"){
            switch (_screen) {
              case 0:
                grid = _length>1&& position?12:24;
                break;
              case 1:
                grid = _length>2?8:_length>1?12:24;
                break;
              case 2:
                grid = _length>2?8:_length>1?12:24;
                break;
              case 3:
                grid = _length>3?6:_length>2?8:_length>1?12:24;
                break;
              case 4:
                grid = _length>3?6:_length>2?8:_length>1?12:24;
                break;
              default:
                grid = 24;
            }
        }else if(_size=="x_largel"){
            switch (_screen) {
              case 0:
                grid = _length>1&& position?12:24;
                break;
              case 1:
                grid = _length>2?8:_length>1?12:24;
                break;
              case 2:
                grid = _length>2?8:_length>1?12:24;
                break;
              case 3:
                grid = _length>2?8:_length>1?12:24;
                break;
              case 4:
                grid = _length>2?8:_length>1?12:24;
                break;
              default:
                grid = 24;
            }
        }else{
            switch (_screen) {
            case 0:
              grid = _length>3&&position?6:_length>2?8:_length>1?12:24;
              break;
            case 1:
              grid = _length>5?4:_length>3?6:_length>2?8:_length>1?12:24;
              break;
            case 2:
              grid = _length>7?3 :_length>5?4:_length>3?6:_length>2?8:_length>1?12:24;
              break;
            case 3:
              grid = _length>7?3 :_length>5?4:_length>3?6:_length>2?8:_length>1?12:24;
              break;
            case 4:
              grid = _length>7?3 :_length>5?4:_length>3?6:_length>2?8:_length>1?12:24;
              break;
            default:
              grid = 24;
          }
        }
        // console.log("grid:",grid);
        return grid;
    },
    //左右栅格比例
    getGridOne(_txt,_img,_duty,_type){
      //_txt  文字内容
      //_img  图片url
      //_duty 栅格比列
      //_type 0图片 1文字
      var grid = 0;
      if(_txt!==''&&_img!==''){
        switch (_duty=='dutyOne'?0:_duty=='dutyThree'?1:2) {
          case 0:
            grid =  _type==0?16:8;
            break;
          case 1:
            grid =  _type==1?16:8;
            break;
          default:
            grid = 12;
        }
        //  grid = 24;
      }else if((_txt!==''&&_img!==''&&_type==1)||(_txt!==''&&_img!==''&&_type==0)){
        grid = 12;
      }else{
        grid = 24;
      }
      return grid;
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>

</style>
